import moment from 'moment';
import { API_DATE_FORMAT } from '../const';
import { IDateRangeType } from '@entities/app';

export const getDefaultDateRange = (): IDateRangeType => ({
    from: moment().subtract(1, 'month').utc().format(API_DATE_FORMAT),
    to: moment().utc().format(API_DATE_FORMAT),
});
